// extracted by mini-css-extract-plugin
export default {"slide":"MWqw60","gallery":"Rf0t45"};